
















































































import Vue from "vue";
import { mapState, mapWritableState } from "pinia";
import { useAuthStore } from "@/stores/auth";
import { useThemeStore } from "@/stores/theme";
import { redirects } from "@/plugins/constrains";
const styleTitle: Record<any, any> = {
  b2oard: '<span class="font-weight-bold">b²oard</span>',
  planeja: 'Planeja<span class="font-weight-bold">Conta</span>',
  localhost: "Ambiente Dev",
};
export default Vue.extend({
  name: "App",
  data: () => ({
    newName: "",
    menu: false,
  }),
  computed: {
    ...mapWritableState(useThemeStore, ["isDark", "lang"]),
    ...mapState(useAuthStore, ["isLogged", "image", "name", "url_back"]),
    hasMenu() {
      return this.$route.meta?.hasMenu;
    },
    aplicationBack() {
      if (!this.url_back) return "";
      const redi = Object.entries(redirects).find((el) =>
        this.url_back.includes(el[1])
      );
      if (redi) {
        return styleTitle[redi[0]] || "";
      }
      return "";
    },
  },
  watch: {
    isDark: {
      handler: function (value) {
        this.$vuetify.theme.dark = value;
      },
      immediate: true,
    },
    lang: {
      handler: function (value) {
        this.$i18next.changeLanguage(value);
      },
      immediate: true,
    },
  },
});
